import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

const SendSMS = Loadable(lazy(() => import("pages/sms/SendSMS")));
const SendSMSAllPerson = Loadable(lazy(() => import("pages/sms/SendSMSAllPerson")));

const SMSRoutes = {
  path: "sms",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "selected-person",
      element: <SendSMS />,
    },
    {
      path: "all-persons",
      element: <SendSMSAllPerson />,
    },
  ],
};

export default SMSRoutes;
